import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { AltaDenunciaComponent } from './alta-denuncia/alta-denuncia.component';
import { ConfirmacionDenunciaComponent } from './confirmacion-denuncia/confirmacion-denuncia.component';
import { DashboardDenunciasComponent } from './dashboard-denuncias/dashboard-denuncias.component';
import { KanbanDenunciasComponent } from './kanban-denuncias/kanban-denuncias.component';
import { DetalleDenunciaComponent } from './detalle-denuncia/detalle-denuncia.component';

@NgModule({
  declarations: [],
  imports: [
    AltaDenunciaComponent,
    ConfirmacionDenunciaComponent,
    DashboardDenunciasComponent,
    KanbanDenunciasComponent,
    DetalleDenunciaComponent,
    CommonModule,
    FormsModule,
    RouterModule
  ],
  exports: [
    AltaDenunciaComponent,
    ConfirmacionDenunciaComponent,
    DashboardDenunciasComponent,
    KanbanDenunciasComponent,
    DetalleDenunciaComponent
  ]
})
export class DenunciasModule {}
